import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import {
    DashboardSalesInvoiceRow,
    DashboardSupplierShipmentRow,
} from './models/dashboard-api.models';

@Injectable({ providedIn: 'root' })
export class DashboardService {
    private _apiUrl = environment.apiUrl;
    private _httpClient = inject(HttpClient);

    getDashboardData() {
        return this._httpClient.get(`${this._apiUrl}/v1/dashboard/get-dashboard-data`);
    }

    getLiveShipmentsData(body: any) {
        return this._httpClient.post(`${this._apiUrl}/v1/dashboard/get-live-shipments-data`, body);
    }

    getDashboardSupplierShipments(dateRange: { startDate: string, endDate: string; }): Observable<DashboardSupplierShipmentRow[]> {
        return this._httpClient.get<DashboardSupplierShipmentRow[]>(
            `${this._apiUrl}/v1/dashboard/get-dashboard-supplier-shipments`,
            { params: { startDate: dateRange.startDate, endDate: dateRange.endDate } },
        );
    }

    getDashboardSalesInvoices(dateRange: { startDate: string, endDate: string; }): Observable<DashboardSalesInvoiceRow[]> {
        return this._httpClient.get<DashboardSalesInvoiceRow[]>(
            `${this._apiUrl}/v1/dashboard/get-dashboard-sales-invoices`,
            { params: { startDate: dateRange.startDate, endDate: dateRange.endDate } },
        );
    }
}